import styled from 'styled-components'

export const FinalizadoContainer = styled.div`
  text-align: center;
`

export const WordingContainer = styled('div')`
  padding: 32px 20px;

  @media (min-width: ${({ theme }) => theme.screen.smMin}) {
    padding: 36px 22px;
  }
`
